import { getRequest } from '@/utils/axios'

export default {
  sitiInfo: {},
  newsInfo: {},
  currentLanguge: '',
  msgnum: 0,
  competitionIntroduction: {},
  articles: [],
  globalDataArray: {},
  modalStates: {
    signway: false,
    formsign: false,
    formapply: false,
    formmsg: false,
    formxieyi: false,
    formEntry: false,
    qrCode: false,
    agreementContent: '',
    noticeContent: '',
    hasAgreementUpdate: 0,
    hasNoticeUpdate: 0
  },
  currentTime: 0,
  saitiStatusCont: {
    hasChild: false,
    signup: '',
    isSignup: 0,
    hasAgreementUpdate: 0,
    hasNoticeUpdate: 0,
    mark: [],
    organizersLogo: [],
    organizers: [],
    localEndtime: '',
    localStarttime: '',
    localEndtimeStr: 0
  }
}
